import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NeuButton, NeuCard } from "../../components/neu/Neu";
import { getBonus } from "../../api/bonuses";

const ROWS = ["serial_number", "employee_name", "amount", "currency", "reason", "payment_source_type",
  "payment_source_name", "status", "paid_at", "journal_entry_number", "received_at", "confirmation_status",
  "confirmation_note", "reminder_sent_at", "cancellation_reason", "created_by_name", "created_at"];

// نافذة تفاصيل المكافأة مع رقم القيد المحاسبي وأثر الاستلام.
export const BonusDetail = ({ bonusId, onClose }) => {
  const { t } = useTranslation();
  const [doc, setDoc] = useState(null);

  useEffect(() => {
    if (bonusId) getBonus(bonusId).then(setDoc);
  }, [bonusId]);

  if (!bonusId) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-background/80 p-4"
         data-testid="bonus-detail-modal" onClick={onClose}>
      <NeuCard className="grid w-full max-w-2xl gap-3" onClick={(e) => e.stopPropagation()}>
        <h3 className="text-base font-black">{t("bonus.detail.title")}</h3>
        <div className="grid gap-1 sm:grid-cols-2">
          {ROWS.filter((key) => doc && doc[key] !== null && doc[key] !== undefined && doc[key] !== "").map((key) => (
            <div key={key} className="flex items-center justify-between gap-2 border-b border-border/30 py-1">
              <span className="text-[11px] text-muted-foreground">{t(`bonus.detail.${key}`, key)}</span>
              <span className="num text-xs font-bold">{String(doc[key])}</span>
            </div>
          ))}
        </div>
        <NeuButton data-testid="bonus-detail-close" onClick={onClose}>{t("common.close")}</NeuButton>
      </NeuCard>
    </div>
  );
};
